import { useEffect, useState } from "react";
import { fetchWishlistItems, type WishlistItem } from "../api/contentful";

export function useWishlistItems() {
  const [data, setData] = useState<WishlistItem[] | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetchWishlistItems()
      .then((res) => setData(res))
      .catch((err) =>
        setError(err instanceof Error ? err.message : "Failed to load wishlist"),
      )
      .finally(() => setLoading(false));
  }, []);

  return { data, loading, error };
}

